import { render, staticRenderFns } from "./Formgroup.vue?vue&type=template&id=6805e70d&scoped=true&"
import script from "./Formgroup.vue?vue&type=script&lang=js&"
export * from "./Formgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805e70d",
  null
  
)

export default component.exports